/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Kind_AllInputs */

const cs_pipelines_kind_all = /** @type {(inputs: Pipelines_Kind_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny typy`)
};

const en_pipelines_kind_all = /** @type {(inputs: Pipelines_Kind_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All types`)
};

/**
* | output |
* | --- |
* | "All types" |
*
* @param {Pipelines_Kind_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_kind_all = /** @type {((inputs?: Pipelines_Kind_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Kind_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_kind_all(inputs)
	return cs_pipelines_kind_all(inputs)
});